import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Image, Dropdown, Button } from 'react-bootstrap';
import '../style/navbar.css'; // Estilos customizados
//import api from '../redux/actions/configApi'; // Importe sua API aqui
import { useNavigate } from 'react-router-dom'; // Assumindo que você está usando React Router
import { useDispatch } from "react-redux";
import { checkAuth, logout  } from '../redux/reducers/userSlice';
import { FaUserCircle } from 'react-icons/fa';

const CustomNavbar = ({ toggleSidebar }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState()

  // const { user, loading } = useSelector((state) => state.user)
  const handleLogout = async () => {
    try {
      // Dispara a action de logout do reducer
      await dispatch(logout()).unwrap();
      navigate('/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      navigate('/login');
    }
  };
  useEffect(() => {
    const fetchAuth = async () => {
      try {
        const userResult = await dispatch(checkAuth()).unwrap();
        setUser(userResult)
        // Aqui você pode atualizar o estado ou executar outras ações se necessário.
      } catch (error) {
        console.error('Erro ao autenticar usuário:', error);
      }
    };
    fetchAuth();
  }, [dispatch]);

  // console.log(useSelector((state) => state.user),'user')
  return (
    <Navbar bg="light" expand="lg" className="navbar-top fixed-top">
      <Button
        variant="light"
        className="d-lg-none" // Só visível no mobile
        onClick={toggleSidebar} // Chama a função para abrir a sidebar
      >
        <i className="fas fa-bars"></i> {/* Ícone de "menu" */}
      </Button>

      {/* Elementos alinhados à direita */}
      <Navbar.Collapse className="justify-content-end">
        <Nav>
          {/* Avatar e Menu do Usuário */}
          <Dropdown style={{ marginRight: "70px" }}>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              <FaUserCircle size={30} className="avatar-icon" /> {/* Ícone substituindo a imagem */}
              {" "}{user?.name?.split(" ")[0]}
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ marginRight: "40px" }}>
              <Dropdown.Item href="/editar-usuario">Editar Perfil</Dropdown.Item>
              <Dropdown.Item onClick={handleLogout}>Sair</Dropdown.Item> {/* Chama handleLogout */}
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default CustomNavbar;
